const contentMessage = {
  dataNotFound: 'Nema podataka!'
};

export { contentMessage };
